import * as React from 'react';
import { SubtitleOne } from '@leagueplatform/genesis-commons';
import { Icon } from '@leagueplatform/genesis-core';
import { MetricType } from '@leagueplatform/dashboard-api';
import {
  useDataTypeConfigMap,
  isSupportedUnitMetricType,
} from '#constants/use-data-type-config.ts';
import { ListItemLink } from '#components/list-item/index.ts';

type NoDataCardProps = {
  dataType: MetricType;
  to: string;
};

export function NoDataCard({ dataType, to }: NoDataCardProps) {
  const dataTypeConfig = useDataTypeConfigMap();

  if (!isSupportedUnitMetricType(dataType)) return null;
  const metric = dataTypeConfig.metric(dataType);

  return (
    <ListItemLink data-testid="unavailable-metric" to={to}>
      <SubtitleOne>{metric}</SubtitleOne>
      <Icon
        icon="interfaceChevronForward"
        size="$oneAndHalf"
        tint="$onSurfaceTextSubdued"
        css={{
          transform: 'translateX(8px)',
        }}
      />
    </ListItemLink>
  );
}
